import React, { Component } from 'react';
import { Date } from '../shared';

class DiscountDetails extends Component {
  render() {
    const { discount } = this.props;

    return (
      <div>
        <div className="form-group">
          <label>Omschrijving staffel:</label>
          <span className="form-control auto-height">
            {discount.qdDesc}
          </span>
        </div>
        <div className="form-group">
          <label>Artikel:</label>
          <span className="form-control auto-height">
            {discount.vartDesc1}
          </span>
        </div>
        <div className="form-group">
          <label>Startdatum:</label>
          <span className="form-control">
            <Date value={discount.begDate} />
          </span>
        </div>
        <div className="form-group">
          <label>Einddatum:</label>
          <span className="form-control">
            <Date value={discount.endDate} />
          </span>
        </div>
        <div className="form-group">
          <label>Vervoermethode:</label>
          <span className="form-control">
            {discount.shipMth}
          </span>
        </div>
        <div className="form-group">
          <label>Betalingsconditie:</label>
          <span className="form-control">
            {discount.discCode}
          </span>
        </div>
        <div className="form-group">
          <label>Ov.Kst. p. ink eenh.:</label>
          <span className="form-control">
            {discount.costInkpu}
          </span>
        </div>
        <div className="form-group">
          <label>Inklaringspercentage:</label>
          <span className="form-control">
            {discount.k1Inkpct}
          </span>
        </div>
        <div className="form-group">
          <label>Kortingspercentage:</label>
          <span className="form-control">
            {discount.k1Krtpct}
          </span>
        </div>
        <div className="form-group">
          <label>Std pakinhoud:</label>
          <span className="form-control">
            {discount.k1Packcont}
          </span>
        </div>
        <div className="form-group">
          <label>Bonus:</label>
          <span className="form-control">
            {discount.vBonPct}
          </span>
        </div>
        <div className="form-group" />
      </div>
    );
  }
}

export default DiscountDetails;



// WEBPACK FOOTER //
// ./src/discounts/DiscountDetails.js